export default __webpack_public_path__ + "static/media/Baphomet2.fc7e95cf.png";